module.exports = __webpack_public_path__ + "static/media/triangle.0bc521e7.svg";